import { FormBase } from "../../../util/form-base-form";

export interface ChipPickerDomOptions {
    removeAction?: string;
    idAttribute?: string;
}

class ChipPickerDomFormBase extends FormBase {
    public getClosestByAction(target: EventTarget | Element | null | undefined, action: string): HTMLElement | null {
        return this.closest(target, `[data-action="${action}"]`, HTMLElement);
    }

    public getClearButtons(root: ParentNode): HTMLButtonElement[] {
        return this.queryElements(root, "[data-action='clear_all']", HTMLButtonElement);
    }
}

const chipPickerDomFormBase = new ChipPickerDomFormBase();

export class ChipPickerDom {
    public static getClearButtons(root: ParentNode): HTMLButtonElement[] {
        return chipPickerDomFormBase.getClearButtons(root);
    }

    public static getRemoveIdFromClick(event: MouseEvent, options: ChipPickerDomOptions = {}): string {
        const target = event.target instanceof HTMLElement ? event.target : null;
        if (!target) return "";

        const removeAction = String(options.removeAction || "remove");
        const idAttribute = String(options.idAttribute || "data-item-id");

        const removeBtn = chipPickerDomFormBase.getClosestByAction(target, removeAction);
        if (!(removeBtn instanceof HTMLElement)) return "";

        let element: HTMLElement | null = removeBtn;
        while (element) {
            if (element.hasAttribute(idAttribute)) {
                return String(element.getAttribute(idAttribute) || "").trim();
            }
            element = element.parentElement;
        }

        return "";
    }
}
